const STEPS = [
    {
        n: "01",
        t: "Brief & alignement",
        d: "On échange sur votre marque, vos objectifs, votre cible. Je vous propose des angles créatifs sur-mesure.",
    },
    {
        n: "02",
        t: "Storyboard",
        d: "Je rédige les scripts, sélectionne les hooks et valide avec vous avant tournage.",
    },
    {
        n: "03",
        t: "Tournage",
        d: "Je produis dans mon studio ou en lifestyle. Lumière naturelle, ambiance soignée, plusieurs prises.",
    },
    {
        n: "04",
        t: "Montage & livraison",
        d: "Montage rythmé, sous-titres, musique. Livraison 3 à 7 jours après tournage, en 9:16 + 1:1.",
    },
];

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#FAFAFA]"
        >
            <div className="max-w-[1600px] mx-auto">
                <div className="mb-16">
                    <p className="eyebrow mb-5">Process</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.02] max-w-3xl">
                        Une méthode <span className="italic">claire</span>,<br />
                        un résultat <span className="italic text-fuchsia">premium</span>.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
                    {STEPS.map((s) => (
                        <div
                            key={s.n}
                            className="relative pt-8 border-t border-ink"
                            data-testid={`process-step-${s.n}`}
                        >
                            <p className="font-display italic text-gold text-2xl absolute -top-7 left-0">
                                {s.n}
                            </p>
                            <h3 className="font-display text-2xl text-ink mb-4">{s.t}</h3>
                            <p className="text-[#4A4A4A] text-sm leading-relaxed">{s.d}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
